module.exports = __webpack_public_path__ + "img/202MD.754.5b3a097e.png";